import { color } from '@upstox/upstox-ui';

export const spotCell: CSSFunction = () => ({
  width: '100px',
  height: 0,
  position: 'sticky',
  top: '46px',
  bottom: '10px',
  zIndex: 3,
});

export const spotPriceContainer: CSSFunction = () => ({
  position: 'relative',
});

export const spotPrice: CSSFunction = ({ theme }) => ({
  backgroundColor: color(theme, theme.colors.interactive.primary.default),
  width: '100%',
  height: '20px',
  padding: '2px',
  borderRadius: '2px',
  textAlign: 'center',
  fontFamily: 'Messina Sans',
  fontWeight: 600,
  fontSize: '12px',
  color: color(theme, theme.colors.text[3]),
  position: 'absolute',
  marginTop: '-10px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
});
